// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './i18n'
import myCom from '@/components/myCom.js'
import MinUI from 'mint-ui'
import VueJsonp from 'vue-jsonp'
import axios from 'axios'
import store from './storeUtil'
import SDK from './NIM_Web_SDK_v6.6.6'
Vue.prototype.$http = axios
Vue.prototype.$log = store
Vue.prototype.SDK = SDK
// Vue.prototype.baseURL = "http://fx-t-m.cp1h.com/"
Vue.prototype.baseURL = "https://m.thextrend.com/"
Vue.use(VueJsonp)
import '@/assets/css/base.css'
import 'mint-ui/lib/style.css'
Vue.config.productionTip = false
const {
  myhead,
  mybottom,
  mytips
} = myCom
Vue.use(myhead).use(mybottom).use(mytips)
Vue.use(MinUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = null
// module chunks = 